import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeSignIn } from '../../services/waysAuth';
import { useAuthStore } from '../../store/useAuthStore';

/** The return leg of the Ways sign-in (PO-92 F5.1): finish the PKCE exchange, then go back. */
export default function WaysCallback() {
  const navigate = useNavigate();
  const email = useAuthStore((s) => s.user?.email);
  const [error, setError] = useState<string | null>(null);
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return; // the code is single-use: StrictMode's second run must not spend it
    once.current = true;
    completeSignIn(new URLSearchParams(window.location.search), email)
      .then((back) => { if (back) navigate(back, { replace: true }); })
      .catch((e) => setError(e.message || 'Ways sign-in failed'));
  }, [navigate, email]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
            <span className="text-red-600 text-xl">!</span>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Ways sign-in failed</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">{error}</p>
          <button onClick={() => navigate('/ways', { replace: true })}
            className="px-4 py-2 rounded-lg bg-accent text-white text-sm font-medium hover:bg-accent/90 transition-colors">
            Back to Ways
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-accent border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Completing the Ways sign-in...</p>
      </div>
    </div>
  );
}
